import { z } from 'zod';

const radioTriState = z.union([z.literal('1'), z.literal('0'), z.literal('')]);
const emailFormat = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * DM情報編集フォーム（患者）— Zod schema. Messages match previous inline validation.
 */
export const patientDmInfoFormSchema = z
  .object({
    has_spouse: radioTriState,
    has_children: radioTriState,
    children_num: z.string(),
    dm_occupation_type_id: z.string(),
    company_name: z.string(),
    mobilephone: z.string(),
    email: z.string(),
    dm_reason_type_id: z.string(),
    is_enable_dm: radioTriState,
    free01: z.string(),
    free02: z.string(),
    free03: z.string(),
    free04: z.string(),
    free05: z.string(),
    free06: z.string(),
    free07: z.string(),
    free08: z.string(),
    free09: z.string(),
    free10: z.string(),
    remarks: z.string(),
  })
  .superRefine((data, ctx) => {
    if (data.email && !emailFormat.test(data.email)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'メールアドレスを正しいメールアドレスにしてください。',
        path: ['email'],
      });
    }

    if (data.company_name && data.company_name.length > 255) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: '勤務先は255文字以下にしてください。',
        path: ['company_name'],
      });
    }

    if (data.mobilephone) {
      const onlyAllowedChars = /^[0-9-]+$/.test(data.mobilephone);
      const digitCount = (data.mobilephone.match(/[0-9]/g) || []).length;
      if (!onlyAllowedChars || digitCount < 7) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: '携帯番号の書式が正しくありません。',
          path: ['mobilephone'],
        });
      }
    }

    if (data.has_children === '1') {
      if (!data.children_num) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: '子供人数を入力してください',
          path: ['children_num'],
        });
      } else {
        const num = Number(data.children_num);
        if (!Number.isInteger(num)) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '子供人数は整数にしてください。',
            path: ['children_num'],
          });
        } else if (num < 0) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '子供人数は0以上にしてください。',
            path: ['children_num'],
          });
        } else if (num < 1) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '子供人数は1以上99以下にしてください。',
            path: ['children_num'],
          });
        } else if (num > 99) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: '子供人数は1以上99以下にしてください。',
            path: ['children_num'],
          });
        }
      }
    }
  });

export type DmInfoFormData = z.infer<typeof patientDmInfoFormSchema>;

export const emptyDmInfoForm: DmInfoFormData = {
  has_spouse: '',
  has_children: '',
  children_num: '',
  dm_occupation_type_id: '',
  company_name: '',
  mobilephone: '',
  email: '',
  dm_reason_type_id: '',
  is_enable_dm: '',
  free01: '',
  free02: '',
  free03: '',
  free04: '',
  free05: '',
  free06: '',
  free07: '',
  free08: '',
  free09: '',
  free10: '',
  remarks: '',
};
